import { render, staticRenderFns } from "./Conta.vue?vue&type=template&id=4fc7dd82&"
import script from "./Conta.vue?vue&type=script&lang=js&"
export * from "./Conta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports